import { Color, FontWeight, Spacing } from '@billy/design-system'
import { StyleSheet } from '@react-pdf/renderer'

export const commonPdfTableStyles = StyleSheet.create({
  /* Table wrapper */
  wrapper: {
    width: '100%',
  },
  /* Single row - might be a header row as well */
  row: {
    width: '100%',
    flexDirection: 'row',
    alignItems: 'stretch',
    flexWrap: 'nowrap',
    gap: Spacing.S8,
    padding: Spacing.S4,
  },
  /* Black row (usually main header) */
  headerRow: {
    backgroundColor: Color.Black,
    marginTop: Spacing.S4,
  },
  /* Grey row (usually subheader or similar sub- part) */
  subHeaderRow: {
    backgroundColor: Color.Grey200,
  },
  headerText: {
    color: Color.White,
    fontSize: '10px',
    fontWeight: FontWeight.Bold,
    wordBreak: 'break-word',
  },
  subHeaderText: {
    color: Color.Black,
    fontSize: '10px',
    fontWeight: FontWeight.Bold,
    wordBreak: 'break-word',
  },
  /* Black header text for transparent headers */
  headerLabelText: {
    color: Color.Black,
    fontSize: '10px',
    fontWeight: FontWeight.Bold,
    wordBreak: 'break-word',
  },
  bodyText: {
    color: Color.Black,
    fontSize: '10px',
    wordBreak: 'break-word',
  },
  cell: {
    flexGrow: 1,
    flexBasis: 0,
    justifyContent: 'center',
    minWidth: 0,
  },
  cellRight: {
    alignItems: 'flex-end',
  },
})
